import { ActionTree } from 'vuex'
import * as types from './types'
export default <ActionTree<appbase.state.AppbaseState, RootState>>{

    [types.MODAL_CHANGE](action, option: settings.ModalOption | null) {
        action.commit(types.MODAL_CHANGE, option)
    },
}
